export default __webpack_public_path__ + "static/media/placeholder_csv.11f3a286.svg";